import axiosInstance from '../axiosInstance';
import getHeaders from './getHeaders';
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus';
import getHeadersformdata from './getHeaderFormdata';

export const makeApiCall = async ({ method, endpoint, data = null, dispatch, requestType = '', successType, failureType, params = {} }) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    const url = `${API_URL}${endpoint}`;

    const options = {
        method,
        headers: getHeaders(),
        url,
        params,
        ...(data && { data }),
    };

    dispatch({ type: requestType });

    try {
        const response = await axiosInstance(options);

        if (response.status === HTTP_STATUS.SUCCESS || response.status === HTTP_STATUS.CREATED) {
            dispatch({ type: successType, payload: response?.data });
            return { status: response?.status, message: response?.data?.message };
        } else {
            throw new Error('Invalid response status');
        }
    } catch (error) {
        const errorData = error?.response?.data || {};
        const nameError = Array.isArray(errorData?.name) ? errorData?.name?.[0] : '';
        const emailError = Array.isArray(errorData?.email) ? errorData?.email?.[0] : '';
        const errorMessage = errorData?.error || nameError || emailError || error?.message || 'An error occurred';
        // const errorMessage = error?.response?.data?.error || error?.response?.data?.name[0] || error?.response?.data?.email[0] || error.message || 'An error occurred';
        dispatch({ type: failureType, payload: errorMessage });
        return { status: error?.response?.status || 500, message: errorMessage };
    }
};

export const makeApiCallWithFile = async ({ method, endpoint, data = null, dispatch, requestType = '', successType, failureType, params = {} }) => {
    const API_URL = localStorage.getItem('countryBackendUrl');
    const url = `${API_URL}${endpoint}`;

    const options = {
        method,
        headers: getHeadersformdata(),
        url,
        params,
        ...(data && { data }),
    };

    dispatch({ type: requestType });

    try {
        const response = await axiosInstance(options);

        if (response.status === HTTP_STATUS.SUCCESS || response.status === HTTP_STATUS.CREATED) {
            dispatch({ type: successType, payload: response?.data });
            return { status: response?.status, message: response?.data?.message };
        } else {
            throw new Error('Invalid response status');
        }
    } catch (error) {
        const errorData = error?.response?.data || {};
        const nameError = Array.isArray(errorData?.name) ? errorData?.name?.[0] : '';
        const emailError = Array.isArray(errorData?.email) ? errorData?.email?.[0] : '';
        const errorMessage = errorData?.error || nameError || emailError || error?.message || 'An error occurred';
        // const errorMessage = error?.response?.data?.error || error?.response?.data?.name[0] || error?.response?.data?.email[0] || error.message || 'An error occurred';
        dispatch({ type: failureType, payload: errorMessage });
        return { status: error?.response?.status || 500, message: errorMessage };
    }
};
